var getNative = require('./_getNative');

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;



//////////////////
// WEBPACK FOOTER
// ./~/_lodash@4.17.4@lodash/_nativeCreate.js
// module id = 1224
// module chunks = 0